"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.capitalize = exports.getColorBySeverity = exports.leftPad = void 0;
const chalk = require("chalk");
function leftPad(text, padding = 4) {
    return padding <= 0 ? text : ' '.repeat(padding) + text;
}
exports.leftPad = leftPad;
function getColorBySeverity(severity) {
    switch (severity) {
        case 'low':
            return chalk.blueBright;
        case 'medium':
            return chalk.yellowBright;
        case 'high':
            return chalk.redBright;
        case 'critical':
            return chalk.magentaBright;
        default:
            return chalk.whiteBright;
    }
}
exports.getColorBySeverity = getColorBySeverity;
function capitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
exports.capitalize = capitalize;
//# sourceMappingURL=common.js.map